import { z } from "zod";
export var OrganizationBankAccountCurrency;
(function (OrganizationBankAccountCurrency) {
    OrganizationBankAccountCurrency["CRC"] = "CRC";
    OrganizationBankAccountCurrency["USD"] = "USD";
})(OrganizationBankAccountCurrency || (OrganizationBankAccountCurrency = {}));
export const organizationBankAccountCurrencyOptions = [
    OrganizationBankAccountCurrency.CRC,
    OrganizationBankAccountCurrency.USD,
];
export function normalizeOrganizationBankAccountIban(value) {
    return value.replace(/\s+/g, "").toUpperCase();
}
export function formatOrganizationBankAccountIban(value) {
    return normalizeOrganizationBankAccountIban(value).replace(/(.{4})/g, "$1 ").trim();
}
export function isValidOrganizationBankAccountIban(value) {
    const iban = normalizeOrganizationBankAccountIban(value);
    if (!/^[A-Z]{2}\d{2}[A-Z0-9]{11,30}$/.test(iban)) {
        return false;
    }
    const rearranged = `${iban.slice(4)}${iban.slice(0, 4)}`;
    let remainder = 0;
    for (const char of rearranged) {
        const replacement = ibanCharToDigits(char);
        if (!replacement)
            return false;
        for (const digit of replacement) {
            remainder = (remainder * 10 + Number(digit)) % 97;
        }
    }
    return remainder === 1;
}
export const organizationBankAccountSchema = z.object({
    bank_name: z.string().trim().min(1, "Ingrese el banco"),
    beneficiary_name: z.string().trim().min(1, "Ingrese el beneficiario"),
    iban: z
        .string()
        .trim()
        .min(15, "Ingrese un IBAN válido")
        .max(42, "Ingrese un IBAN válido")
        .transform(normalizeOrganizationBankAccountIban)
        .refine(isValidOrganizationBankAccountIban, "Ingrese un IBAN válido"),
    currency: z.nativeEnum(OrganizationBankAccountCurrency),
});
export const defaultOrganizationBankAccountInput = {
    bank_name: "",
    beneficiary_name: "",
    iban: "",
    currency: OrganizationBankAccountCurrency.CRC,
};
function ibanCharToDigits(char) {
    if (/^\d$/.test(char))
        return char;
    if (/^[A-Z]$/.test(char))
        return String(char.charCodeAt(0) - 55);
    return null;
}
